const TEACHER_AUTH_KEY = "teacherAuth";
const TEACHER_SIGNUP_CONTEXT_KEY = "teacherSignupContext";
const ADMIN_AUTH_TOKEN_KEY = "adminAuthToken";
const ADMIN_JWT_KEY = "adminJwt";

const safeStorageGet = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    return null;
  }
};

const safeStorageSet = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`Unable to persist ${key}:`, error);
  }
};

const safeStorageRemove = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`Unable to remove ${key}:`, error);
  }
};

const safeParse = (value, fallbackValue) => {
  if (!value) return fallbackValue;

  try {
    return JSON.parse(value);
  } catch (error) {
    return fallbackValue;
  }
};

export const normalizeTeacherToken = (tokenValue) => {
  if (!tokenValue || typeof tokenValue !== "string") return "";

  return tokenValue
    .replace(/^['"]+|['"]+$/g, "")
    .replace(/^(Token|Bearer)\s+/i, "")
    .trim();
};

export const getStoredTeacherAuth = () => {
  const parsed = safeParse(safeStorageGet(TEACHER_AUTH_KEY), {});

  return {
    token: normalizeTeacherToken(String(parsed?.token || "")),
    teacher:
      parsed?.teacher && typeof parsed.teacher === "object" ? parsed.teacher : null,
  };
};

export const persistTeacherAuth = (authPayload = {}) => {
  const nextAuth = {
    token: normalizeTeacherToken(String(authPayload?.token || "")),
    teacher:
      authPayload?.teacher && typeof authPayload.teacher === "object"
        ? authPayload.teacher
        : null,
  };

  safeStorageSet(TEACHER_AUTH_KEY, nextAuth);
  return nextAuth;
};

export const clearStoredTeacherAuth = () => {
  safeStorageRemove(TEACHER_AUTH_KEY);
};

export const getStoredTeacherToken = () => getStoredTeacherAuth().token;

export const getStoredTeacherSignupContext = () => {
  const parsed = safeParse(safeStorageGet(TEACHER_SIGNUP_CONTEXT_KEY), {});

  return {
    preAuthToken: String(parsed?.preAuthToken || "").trim(),
    email: String(parsed?.email || "").trim(),
    source: String(parsed?.source || "signup").trim() || "signup",
  };
};

export const persistTeacherSignupContext = (signupContext = {}) => {
  const nextContext = {
    preAuthToken: String(signupContext?.preAuthToken || "").trim(),
    email: String(signupContext?.email || "").trim(),
    source: String(signupContext?.source || "signup").trim() || "signup",
  };

  safeStorageSet(TEACHER_SIGNUP_CONTEXT_KEY, nextContext);
  return nextContext;
};

export const clearStoredTeacherSignupContext = () => {
  safeStorageRemove(TEACHER_SIGNUP_CONTEXT_KEY);
};

export const getStoredAdminAuthContext = () => {
  const storedAdminAuthToken = normalizeTeacherToken(
    String(safeParse(safeStorageGet(ADMIN_AUTH_TOKEN_KEY), safeStorageGet(ADMIN_AUTH_TOKEN_KEY)) || "")
  );
  const storedAdminJwt = normalizeTeacherToken(
    String(safeParse(safeStorageGet(ADMIN_JWT_KEY), safeStorageGet(ADMIN_JWT_KEY)) || "")
  );

  return {
    authToken: storedAdminAuthToken,
    jwt: storedAdminJwt,
  };
};

export const teacherStorageKeys = {
  teacherAuth: TEACHER_AUTH_KEY,
  teacherSignupContext: TEACHER_SIGNUP_CONTEXT_KEY,
  adminAuthToken: ADMIN_AUTH_TOKEN_KEY,
  adminJwt: ADMIN_JWT_KEY,
};
